import { ChevronDown } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";
import { useState } from "react";

export default function ProductAccordion({ items }) {
  const [open, setOpen] = useState(items[0]?.title);

  return (
    <div className="rounded-[2rem]  shadow-xl shadow-black/5">
      {items.map((item) => {
        const isOpen = open === item.title;

        return (
          <div key={item.title} className="border-b border-border/60 last:border-b-0">
            <button
              type="button"
              onClick={() => setOpen(isOpen ? "" : item.title)}
              className="flex w-full items-center justify-between px-6 py-5 text-left font-medium "
              aria-expanded={isOpen}
            >
              {item.title}
              <ChevronDown className={`size-4 transition ${isOpen ? "rotate-180" : ""}`} />
            </button>

            <AnimatePresence>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  className="overflow-hidden"
                >
                  <div className="px-6 pb-6 text-sm leading-7 text-muted-foreground">
                    {item.content}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
